/**
 * Authentication Hooks - Barrel Export
 *
 * Centralized exports for all authentication-related hooks
 */

export { useLogin } from './useLogin';
export type { LoginResponse, LoginResult } from './useLogin';
